import { Box, Paper } from "@material-ui/core";
import BackupIcon from '@mui/icons-material/Backup';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import ReplyIcon from '@mui/icons-material/Reply';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip
} from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import Button from '@mui/material/Button';
import Fade from '@mui/material/Fade';
import Modal from '@mui/material/Modal';
import 'dayjs/locale/en-gb';
import React, { useEffect, useMemo, useState } from 'react';
import Swal from 'sweetalert2';
import axios from '../../../utils/axios';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import 'dayjs/locale/en-gb';
import {
  MaterialReactTable,
  useMaterialReactTable
} from 'material-react-table';
import LoaderBar from "../../../components/LoaderBar/LoaderBar";
import PageTitle from "../../../components/PageTitle/PageTitle";
import PdfUpload from "../../../utils/Uploader/PdfUpload";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#A7C7E7",
    color: theme.palette.common.black,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));


const SettlementPDF = () => {


const [fileURL,setFileURL] = useState("");
  const [data,setData] = useState([]);
  const [dividendType,setDividendType] = useState([]);

  const initialValue = {
    settlementId:0,
    settlementStatus:1001,
    folio_bo_file:fileURL
  
  }
  const [submitValue,setSubmitValue] = useState(initialValue);
const [isLoading,setIsLoading] = useState(false);
const [open,setOpen] = useState(false);
const enableAdd = submitValue.settlementId !== 0  && submitValue.folio_bo_file !=="";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '60%',
  bgcolor: 'background.paper',
  border: '2px solid #eee',
  boxShadow: '2px 2px 2px 2px #eee',
  borderRadius:"10px",
  p: 4
};

  const handleSubmit = (id,table) =>{
    
       const formdata = new FormData();
       formdata.append('settlementId',submitValue.settlementId);
       formdata.append('settlementStatus',submitValue.settlementStatus);
       formdata.append("folio_bo_file",submitValue.folio_bo_file);
          axios.post('/settlement',formdata)
          .then((res)=>{
            if(res.data.statusCode===200)
            {
              setSubmitValue(initialValue);
              Swal.fire({
                customClass: {
                  container: 'my-swal'
                },
                icon: 'success',
                title: 'PDF Uploaded!',
                showConfirmButton: false,
                timer: 3000
              })
              setData((prevData) => prevData.filter((item) => item.settlement_id !== id));
              table.setEditingRow(null);
              setFileURL("");
              setSubmitValue(initialValue);
            }
          })
          .catch((err)=>{
            console.log(err)
            Swal.fire({
                customClass: {
                  container: 'my-swal'
                },
                icon: 'error',
                title: {err},
                showConfirmButton: false,
                timer: 3000
              })
          })
  }
  
 


    
    const getReadyToSettledList = async () =>{
      setIsLoading(true);
      try
      {
        const dividenTypeApiHit = await axios.get('/inward-dividend/get-dividend-types')  
        let dividenTypeApiRes = dividenTypeApiHit.data.payload; 
        const response = await axios.get('/settlement/get-by-settlement-status/3')
           let res = response.data.payload;
        // console.log(response);
        let modifiedData =[]
        res.map(item =>{
          const rowWithFetchedId = dividenTypeApiRes.find(row => row.id === item.investor_dividend_type_id);
          const labelToShow = rowWithFetchedId ? rowWithFetchedId.investorDividendType+ "("+rowWithFetchedId.dividendType+")"  : item.investor_dividend_type_id;
          const cashorstock = rowWithFetchedId ? rowWithFetchedId.dividendType  : item.investor_dividend_type_id;

          const createdatdateformat = new Date(item.createdat).toISOString().split("T")[0];
          const YearList = item.years.join(", ");
          delete item.years;
          modifiedData.push({...item,investorDividendType:labelToShow,yearlist:YearList,dividendType:cashorstock,createdat:createdatdateformat})
        })
        setData(modifiedData);
        setIsLoading(false);
        setDividendType(dividenTypeApiRes);
        
      }
      catch(error)
      {
        setIsLoading(false);
        console.log(error);
        Swal.fire({
                    icon: 'error',
                    title: `Error fetching ready to settled list: ${error.response?.data?.message || error.message}`,
                    showConfirmButton: true,
                    // timer: 3000
                  })
      }
      
    }

     const handleFileUploadPDF = (event) => {
          
          const file = event.target.files[0];
          
          setFileURL(URL.createObjectURL(file));
          if (file.type === "application/pdf" ) 
            {
              setSubmitValue( prevValues => {
                return { ...prevValues,folio_bo_file: file}
              })
              setOpen(true); 
          }
          else
          {
            Swal.fire({
              icon: 'warning',
              title: 'File does not support. You must use .pdf ',
              showConfirmButton: true,
              // timer: 3000
            })
            return;
          }
          
          
        };
       

    const handleOpenPreview = () =>{
        return(
          <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={()=>{setOpen(false);} }
          closeAfterTransition
          BackdropComponent={Backdrop}
          slots={{ backdrop: Backdrop }}
          slotProps={{
          backdrop: {
              timeout: 500,
          }}}
         style={{overflow: "auto", display:"flex",justifyContent:"center",alignItems:"center", textAlign:"center", borderRadius:"10px"
         }}
         >
          <Fade in={open}>
          <Box sx={style} style={{textAlign:"center",width:"80%",height:"80vh"}} >
              <h3>PDF PREVIEWER </h3>
              <Box className="form-control" style={{textAlign:"center",height:"90%"}}>
                  {fileURL ? (
                      // <div
                      //     style={{
                      //         border: '1px solid rgba(0, 0, 0, 0.3)',
                      //         height: '100%',
                      //     }}
                      // >
                      //     <Viewer fileUrl={fileURL} />
                      // </div>
                      <iframe
                          src={fileURL}
                          width="100%"
                          height="100%"
                          title="PDF Viewer"
                        />
                  ) : (
                      <div
                          style={{
                              alignItems: 'center',
                              border: '2px dashed rgba(0, 0, 0, .3)',
                              display: 'flex',
                              fontSize: '2rem',
                              height: '100%',
                              justifyContent: 'center',
                              width: '100%',
                          }}
                      >
                          Preview area
                      </div>
                  )}
                  
                  <Button type="button" onClick={()=>{setOpen(false);}} variant="contained" color="info" style={{color:"white"}}><ReplyIcon/> Close</Button>
                  </Box>
          </Box>
          </Fade>
      </Modal>
        )
      }
  const columns = useMemo(
    //column definitions...
    () => [
      {
            accessorKey: 'settlementserialno',
            header: 'Settlement Serial ',
      },
      {
        accessorKey: 'bo_id',
        header: 'BOID',
      },
      {
        accessorKey: 'folio_number',
        header: 'Folio Number',
      },
      {
        accessorKey: 'name',
        header: 'Investor Name',
      },
      {
        accessorKey: 'issuer_name',
        header: 'Issuer',
        size: 50,
      },
      
      {
        accessorKey: 'investorDividendType',
        header: 'Investor Dividend Type',
        // Cell: ({ cell }) => {
        //   const id = cell.getValue(); // Get the raw id value
        //   const rowWithFetchedId = dividendType.find(row => row.id === id);
        //   const labelToShow = rowWithFetchedId ? rowWithFetchedId.investorDividendType+ "("+rowWithFetchedId.dividendType+")"  : id;
        //   return labelToShow // Map to label or show 'Unknown' if not found
        // },
      },
      {
        accessorKey: 'total_amount',
        header: 'Amount',
        Cell: ({ row }) => {
          const [openPreview, setOpenPreview] = useState(false);
          const [YearDetailsList, setYearDetailsList] = useState([]);
          const style = {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '60%',
            bgcolor: 'background.paper',
            border: '2px solid #eee',
            boxShadow: '2px 2px 2px 2px #eee',
            borderRadius:"10px",
            p: 4
          };
    
    
          const handlePreviewClick = async () => {
            const response = await axios.get(`settlement/get-by-settlement-details/${row.original.settlement_id}`);
            let res = response.data.payload;
            // console.log(res);
            setYearDetailsList(res);
            // setYearDetailsList([{year:"2010",amount:"507",yearterm:"Third Dividend Year (FYI)"},{year:"2011",amount:"850",yearterm:"Final Dividend Year (FYI)"}
            //   ,{year:"2009",amount:"1150",yearterm:"Second Dividend Year (FYI)"},{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"}
            //   ,{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"},{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"},{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"}
            //   ,{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"},{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"}
            //   ,{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"},{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"}
            //   ,{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"},{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"}
            //   ,{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"},{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"}
            //   ,{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"},{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"}
            //   ,{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"},{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"}
            // ])
            setOpenPreview(true);
          };
          const openModal = () =>{
            return(
            <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openPreview}
            onClose={() => setOpenPreview(false)}
            closeAfterTransition
            BackdropComponent={Backdrop}
            slots={{ backdrop: Backdrop }}
            slotProps={{
            backdrop: {
                timeout: 500,
            }}}
           style={{overflow: "auto", display:"flex",justifyContent:"center",alignItems:"center", textAlign:"center", borderRadius:"10px"
           }}
           >
            <Fade in={openPreview}>
            <Box sx={style} style={{textAlign:"center",width:"80%",height:"80vh"}} >
                <h3>Year wise settled dividend amount details </h3>
                <Paper style={{ margin:"10px 50px 10px 50px",padding:"10px",boxShadow:"2px 2px 2px 2px gray",justifyContent:"center"}} container spacing={2} >
                <TableContainer component={Paper} sx={{ width: '100%',maxHeight: 440}}>
              <Table sx={{ minWidth: 700 }} stickyHeader aria-label="simple table">
                <TableHead style={{fontSize:"1.2rem"}}>
                  <TableRow>
                    <StyledTableCell align="center"  style={{fontSize:"1.2rem"}}>Year</StyledTableCell>
                    <StyledTableCell align="center"  style={{fontSize:"1.2rem"}}>Interim</StyledTableCell>
                    <StyledTableCell align="center"  style={{fontSize:"1.2rem"}}>Cash / Stock</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody style={{overflow:"hidden",maxHeight:440}}>
                  {YearDetailsList.map((row,id) => (
                    <StyledTableRow key={id}>
                      <StyledTableCell align="center">{row.year}</StyledTableCell>
                      <StyledTableCell align="center">{row.yearterm}</StyledTableCell>
                      <StyledTableCell align="center">{row.amount}</StyledTableCell>

                    </StyledTableRow>
                  ))}
                  <StyledTableRow  sx={{
                                position: "sticky",
                                bottom: 0,
                               backgroundColor: "#A7C7E7 !important",
                                zIndex: 2, // Ensures it stays above the content
                              }}>
                  <StyledTableCell align="center" style={{fontSize:"1.2rem"}} colSpan={1}><strong>Total</strong></StyledTableCell>
                  <StyledTableCell align="center" ></StyledTableCell>
                  <StyledTableCell align="center"  style={{fontSize:"1.2rem"}}><strong>{row.original.total_amount}</strong></StyledTableCell>

                    </StyledTableRow>
                </TableBody>
                
              </Table>
            </TableContainer>
            </Paper>
            <Button type="button" onClick={()=>setOpenPreview(false)} variant="contained" color="info" style={{color:"white"}}><ReplyIcon/> Go Back</Button>
            </Box>
            </Fade>
        </Modal>
            )}
    
          return (
            <>
              <Button variant="contained" color="primary" onClick={handlePreviewClick}>
                {row.original.total_amount}
              </Button>
              {
                openPreview && openModal()
              }
            </>
          );
        },
      },
      {
        accessorKey: 'createdby',
        header: 'Entry By',
      },
      {
        accessorKey: 'createdat',
        header: 'Entry Date',
      },
    ],
    [],
    //end
  );

  const table = useMaterialReactTable({
    columns,
    data:data,
    // enableExpandAll: false, //disable expand all button
    // editDisplayMode: 'modal',
    initialState: { density: 'compact' },
    enableEditing: true,
    enableStickyHeader: true,
    enableStickyFooter: true,
    muiPaginationProps: {
      rowsPerPageOptions: [5, 10, 15, 20, 25, 30, 50, 100, data.length]
    },
    muiTableContainerProps: {

      style: { maxHeight: '60vh' } 

  },
    getRowId: (row) => row.id,
    renderTopToolbarCustomActions: ({ table }) => (
      <Box
        sx={{
          display: 'flex',
          gap: '16px',
          padding: '8px',
          flexWrap: 'wrap',
        }}
      >
     
      </Box>
    ),
 
    muiEditRowDialogProps: ({ table, row, internalEditComponents }) => {
        return {
          maxWidth: 'xl'
        }
      },
    renderRowActions: ({ row, table }) => (
    //   <Box sx={{ display: 'flex', gap: '1rem' }}>
        <Tooltip title="Edit">
          <Button variant = "contained" color="secondary" disabled={table.getSelectedRowModel().rows.length >1} 
          onClick={() => {table.setEditingRow(row);
            
                            setSubmitValue(prevState => ({
                                ...prevState,
                                settlementId:row.original.settlement_id
                                }));
                    }}>
             <BackupIcon/>&nbsp;Upload
          </Button>
        </Tooltip>
    //   </Box>
    ),
    onEditingRowCancel:({table,row})=>
        {
            setFileURL("");
            setSubmitValue(prevState => ({
                ...prevState,
                folio_bo_file:""
                }));
        }
    ,
    renderEditRowDialogContent: ({ table, row, internalEditComponents }) => (

      <>
        
        
          <DialogTitle>Upload PDF Document</DialogTitle>
          <DialogContent >
          <div style={{border:"1px solid gray",borderRadius:"5px",width:"100%",padding:"10px",margin:"5px",textAlign:"center"}}>

        {/* <h4>Documents Upload : </h4>
        <Grid container spacing={2}>
        <Grid item lg={6} md={6} sm={12} xs={12} for="pdfupload"  style={{border:"1px dashed gray"}}> <label
                        for="pdfupload"
                        style={{ color: "black", fontWeight: "bold",border:"1px solid green" }}
                        className="btn btn-warning btn-lg"
                        >Upload PDF File <BackupIcon style={{fill:'black'}} /></label>
                        <input
                        required
                            id="pdfupload"
                            name="csvFile"
                            type="file"
                            onChange={(e)=>{
                                handleFileUploadPDF(e);
                            }}
                            style={{ display: "none",visibility:"none" }}
                        />
                        <h4>{submitValue.folio_bo_file?.name}</h4></Grid>
                        {open && handleOpenPreview()}
                    <Grid item lg={6} md={6} sm={12} xs={12} style={{border:"1px dashed gray"}}>
                    
                    <button className="btn btn-primary btn-lg" type="button" style={{color:"white",border:"1px solid black"}} onClick={()=>{setOpen(true);}}><RemoveRedEyeIcon/>Preview Uploaded PDF</button>
                            {open && handleOpenPreview()}
                    </Grid>
                        </Grid> */}
                      <PdfUpload submitValue={submitValue} setSubmitValue={setSubmitValue}/>
                  
                          
</div>
           </DialogContent>
           <DialogActions style={{justifyContent:"center",padding:"5px"}}>
        
          <div className="form-control" style={{textAlign:"center"}}>
         <div>
         <Button type="submit" disabled={!enableAdd} onClick={()=>{handleSubmit(row.original.settlement_id,table);}} variant="contained" 
            color="success" style={{color:"white"}}>
            <DoneAllIcon/> &nbsp;Save PDF</Button>
            
             
         </div>
                           
                            </div>
        </DialogActions>
        
        </>   
       
                    
    )

  });

  useEffect(() => {
    
    getReadyToSettledList();
  
  
  }, [])

  return(
        <>
          <PageTitle title={"Settlement Documents Upload"}></PageTitle>
          {/* <Box>
            <Button variant="contained" color="primary" onClick={handleShowData}> {show ? "Hide Data" : "See Data"}</Button>
          </Box> */}
          
          {
             isLoading
             ?
            <LoaderBar/>
            :
            <MaterialReactTable  table={table} />
          }

          
        </>);
};

export default SettlementPDF;